import React from 'react';

const SvgRadioButton = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 20 20" fill="currentColor" {...props}>
    <path d="M10 5a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm0-5a10 10 0 1 0 10 10A10 10 0 0 0 10 0zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" />
  </svg>
);

export default SvgRadioButton;
